import App from "../application.js";

import "./setup_i18n";
import "jquery-validation/dist/localization/messages_uk.js";
import "../vendor/bootstrap-datepicker/locales/bootstrap-datepicker.uk.js";
import "moment/locale/uk.js";
import "./translations.tc.uk.js";

$.fn.datepicker.defaults.language = "uk";

I18n.defaultLocale = "uk";
I18n.locale = "uk";

export default App;
